/* ============ FOLDKIND · S12 — fk-offers ============ */
/* Sélection des offres + ajout au panier propre à la section.
   Aucun prix n'est calculé ici : toutes les valeurs affichées sont rendues
   par Liquid et lues dans les data-attributs. Le script ne fait que déplacer
   des chaînes déjà formatées par le filtre money du thème. */

class FkOffers extends HTMLElement {
  connectedCallback() {
    this.options = Array.from(this.querySelectorAll('[data-fk-option]'));
    if (!this.options.length) return;

    this.submitButtons = Array.from(this.querySelectorAll('[data-fk-submit]'));
    // Les suffixes -out distinguent les cibles d'écriture des attributs source
    // portés par les options : sans eux, querySelector attrape la première
    // carte et son contenu se fait écraser par le récapitulatif.
    this.recap = this.querySelector('[data-fk-recap-out]');
    this.barLabel = this.querySelector('[data-fk-bar-label-out]');
    this.barPrice = this.querySelector('[data-fk-bar-price-out]');
    this.bar = this.querySelector('[data-fk-bar]');
    this.errorBox = this.querySelector('[data-fk-error]');
    this.live = this.querySelector('[data-fk-live]');

    this.onOptionClick = this.onOptionClick.bind(this);
    this.onOptionKeydown = this.onOptionKeydown.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.options.forEach((el) => {
      el.addEventListener('click', this.onOptionClick);
      el.addEventListener('keydown', this.onOptionKeydown);
    });
    this.submitButtons.forEach((b) => b.addEventListener('click', this.onSubmit));

    // Lien « Prefer a one-time order? See 3 months »
    const swap = this.querySelector('[data-fk-swap]');
    if (swap) {
      swap.addEventListener('click', (e) => {
        e.stopPropagation();
        const target = this.querySelector('[data-fk-option][data-fk-key="' + swap.dataset.fkSwap + '"]');
        if (target) {
          this.select(target);
          target.scrollIntoView({ block: 'center', behavior: this.reducedMotion ? 'auto' : 'smooth' });
        }
      });
    }

    /* Un `?pack=` dans l'URL vient de la page d'accueil : elle renvoie ici
       avec le palier que la cliente avait déjà choisi. Il prime sur le défaut. */
    const demande = new URLSearchParams(window.location.search).get('pack');
    const voulu = demande && this.options.find((el) => el.dataset.fkKey === demande && el.dataset.available !== 'false');
    const preselected = this.options.find((el) => el.dataset.fkDefault === 'true' && el.dataset.available !== 'false');
    this.select(voulu || preselected || this.options.find((el) => el.dataset.available !== 'false') || this.options[0]);

    /* Kaching se rend après nous : au premier passage ses paliers n'existent
       pas encore et la synchro ne trouve rien. On réessaie quelques instants
       pour que les deux sélecteurs affichent le même palier dès l'arrivée. */
    /* `buy=1` : elle arrive d'un clic sur une offre de l'accueil, ou du bouton
       final. Elle a choisi : on la pose devant le selecteur de la boutique et
       son bouton d'ajout, plutot qu'en haut d'une fiche qu'elle vient de
       parcourir. Le parametre est retire de l'URL, un rechargement ne
       redeplace rien. */
    const versLeBundle = new URLSearchParams(window.location.search).get('buy') === '1';
    if (versLeBundle) {
      const url = new URL(window.location.href);
      url.searchParams.delete('buy');
      history.replaceState(null, '', url.pathname + url.search + url.hash);
    }

    let essais = 0;
    const rattraper = setInterval(() => {
      if (this.kachingBars() || ++essais > 20) {
        clearInterval(rattraper);
        if (this.selected) this.syncKaching(this.selected);
        if (versLeBundle) this.allerAuBundle('arrivee');
      }
    }, 250);

    this.measureFold();
    this.foldObserver = new ResizeObserver(() => this.measureFold());
    this.foldObserver.observe(this);

    if (this.bar) this.watchBar();
  }

  disconnectedCallback() {
    if (this.foldObserver) this.foldObserver.disconnect();
    if (this.barObserver) this.barObserver.disconnect();
    document.documentElement.removeAttribute('data-fk-offers-bar');
  }

  get reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Le creux du filet plié vaut 3 px au centre quelle que soit la largeur de
     carte : l'angle doit donc être recalculé, pas figé. */
  measureFold() {
    const fold = this.querySelector('.fk-offers__fold');
    if (!fold) return;
    const half = fold.getBoundingClientRect().width / 2;
    if (half < 1) return;
    const deg = (Math.atan(3 / half) * 180) / Math.PI;
    this.style.setProperty('--fk-fold-angle', deg.toFixed(3) + 'deg');
  }

  onOptionClick(event) {
    if (event.target.closest('[data-fk-swap]')) return;
    const el = event.currentTarget;
    if (el.dataset.available === 'false') return;
    this.select(el);
    this.conclure(el);
  }

  /* ---- Choisir une carte EST le geste ------------------------------------
     Plus de bouton propre a la section, plus d'ajout automatique : la carte
     conduit au selecteur de la boutique, celui qui joint le guide offert, et
     c'est la cliente qui valide. Aucun panier ne se remplit sans son clic sur
     le bouton de la boutique. C'est ce qui rend le double ajout impossible :
     il n'y a plus rien d'automatique a doubler.

     Depuis l'accueil : on part sur la fiche, palier en parametre.
     Sur la fiche : on remonte au bundle Kaching, deja aligne sur son palier.

     Le clavier ne conclut que sur Entree ou Espace. Les fleches parcourent les
     paliers sans rien declencher : sinon un simple parcours au clavier ferait
     quitter la page. */
  conclure(el) {
    const fiche = this.dataset.fkProductUrl;
    if (fiche && fiche.split('?')[0] !== window.location.pathname) {
      const pack = el.dataset.fkKey ? 'pack=' + encodeURIComponent(el.dataset.fkKey) + '&' : '';
      window.location.href = fiche.split('?')[0] + '?' + pack + 'buy=1';
      return;
    }
    this.allerAuBundle();
  }

  /* Sur la fiche, le bundle est douze mille pixels au-dessus de la section :
     un defilement anime y serait interminable et donne le mal de mer. Au-dela
     de deux mille pixels, ou a l'arrivee, on saute. En dessous, on anime. */
  allerAuBundle(origine) {
    const cible = document.querySelector('kaching-bundle')
      || document.querySelector('.kaching-bundles__bar[data-deal-bar-id]');
    if (!cible) return;
    const loin = Math.abs(cible.getBoundingClientRect().top) > 2000;
    cible.scrollIntoView({
      block: 'center',
      behavior: this.reducedMotion || loin || origine === 'arrivee' ? 'instant' : 'smooth',
    });
  }

  onOptionKeydown(event) {
    // Les options sont des role="radio" sur des div : Entrée et Espace ne
    // déclenchent rien tout seuls, il faut les câbler.
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      if (event.target.closest('[data-fk-swap]')) return;
      event.preventDefault();
      const choisie = event.currentTarget;
      if (choisie.dataset.available !== 'false') { this.select(choisie); this.conclure(choisie); }
      return;
    }

    const keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'];
    if (!keys.includes(event.key)) return;
    event.preventDefault();
    const usable = this.options.filter((el) => el.dataset.available !== 'false');
    const i = usable.indexOf(event.currentTarget);
    const step = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
    const next = usable[(i + step + usable.length) % usable.length];
    if (next) { this.select(next); next.focus(); }
  }

  select(el) {
    if (!el) return;
    this.selected = el;
    this.options.forEach((o) => {
      const on = o === el;
      o.setAttribute('aria-checked', on ? 'true' : 'false');
      o.setAttribute('tabindex', on ? '0' : '-1');
      const pick = o.querySelector('[data-fk-picklabel]');
      if (pick) pick.textContent = on ? pick.dataset.fkOn : pick.dataset.fkOff;
    });

    if (this.recap) this.recap.textContent = el.dataset.fkRecap || '';
    if (this.barLabel) this.barLabel.textContent = el.dataset.fkBarLabel || '';
    if (this.barPrice) this.barPrice.textContent = el.dataset.fkPrice || '';
    this.submitButtons.forEach((b) => { b.disabled = el.dataset.available === 'false'; });
    this.clearError();
    if (this.live) this.live.textContent = (el.dataset.fkRecap || '') + ', selected';

    this.syncKaching(el);
  }

  /* ---- Pont vers le bundle Kaching -------------------------------------
     Le guide « Fold Care Guide » n'est pas offert par une remise de la
     boutique : c'est Kaching qui l'ajoute lui-même, dans le même appel que
     la crème, avec une propriété privée `__kaching_bundles` que sa fonction
     Shopify lit pour mettre la ligne à zéro. Répliquer ce format ici serait
     doublement risqué — il n'est pas documenté, et si ses identifiants
     changeaient la cliente paierait 19 $ pour un produit annoncé gratuit,
     sans que rien ne le signale.
     On délègue donc : la section pilote le widget au lieu de l'imiter.
     Toute la logique commerciale reste chez Kaching.

     Les paliers se correspondent un pour un et dans le même ordre
     (1 / 3 / 5 tubes). On ne relie que si les deux comptes coïncident :
     au moindre doute, on retombe sur l'ajout propre à la section. */
  kachingBars() {
    const bars = Array.from(document.querySelectorAll('.kaching-bundles__bar[data-deal-bar-id]'));
    return bars.length === this.options.length ? bars : null;
  }

  kachingButton() {
    return this.kachingBars() ? document.querySelector('button[data-ref=add-to-cart-button]') : null;
  }

  syncKaching(el) {
    const bars = this.kachingBars();
    if (!bars) return;
    const bar = bars[this.options.indexOf(el)];
    if (!bar) return;
    const input = bar.querySelector('input[type=radio]');
    if (input && input.checked) return; // déjà sur le bon palier : ne pas reboucler
    (input || bar).click();
  }

  clearError() {
    if (this.errorBox) { this.errorBox.textContent = ''; this.errorBox.hidden = true; }
  }

  showError(message) {
    if (!this.errorBox) return;
    this.errorBox.textContent = message;
    this.errorBox.hidden = false;
  }

  async onSubmit(event) {
    event.preventDefault();
    const el = this.selected;
    if (!el || el.dataset.available === 'false') return;

    /* Quand le widget Kaching est là — c'est le cas sur la fiche produit —
       c'est LUI qui ajoute au panier, et lui seul sait joindre le guide
       offert. On aligne le palier puis on lui passe la main. Sur la page
       d'accueil il n'existe pas (son bloc est limité aux pages produit) :
       on garde alors l'ajout propre à la section, qui obtient le bon prix
       mais pas le guide. */
    const relais = this.kachingButton();
    if (relais) {
      this.syncKaching(el);
      this.clearError();
      setTimeout(() => relais.click(), 120);
      return;
    }

    /* Pas de widget : on est hors de la fiche produit. Ajouter ici donnerait
       le bon prix mais PAS le guide offert, que Kaching seul sait joindre.
       On renvoie donc vers la fiche, sur le palier choisi, plutôt que de
       remplir un panier incomplet. */
    /* Pas d'ancre : on arrive EN HAUT de la fiche. La cliente vient de la
       page d'accueil, elle n'a pas encore vu le produit — l'envoyer droit
       au sélecteur de packs lui ferait sauter la buy box, les photos et le
       label. Le `?pack=` suffit : son palier l'attend, déjà sélectionné,
       quand elle descend. */
    const fiche = this.dataset.fkProductUrl;
    if (fiche && fiche.split('?')[0] !== window.location.pathname) {
      const cle = (el.dataset.fkKey ? '?pack=' + encodeURIComponent(el.dataset.fkKey) + '&' : '?') + 'add=1';
      window.location.href = fiche + cle;
      return;
    }

    const button = event.currentTarget;
    const idle = button.textContent;
    button.disabled = true;
    button.textContent = button.dataset.fkBusy || idle;
    this.clearError();

    // C'est la quantité qui fait le palier : le deal Kaching applique son prix
    // fixe selon le nombre de tubes, pas selon une variante de pack.
    const body = { items: [{ id: Number(el.dataset.fkVariant), quantity: Number(el.dataset.fkQty) || 1 }] };
    if (el.dataset.fkPlan) body.items[0].selling_plan = Number(el.dataset.fkPlan);

    /* Le tiroir du thème ne se redessine PAS à partir du JSON du panier : il
       attend le HTML de sa propre section, dans `detail.data.sections`, et fait
       `parsedState.sections[sectionId]` sans garde. Sans ces deux clés dans la
       requête, la réponse ne porte aucun `sections`, cart-drawer.js lève
       « Cannot read properties of undefined », et le tiroir s'ouvre sur son
       état d'avant : l'article est bien au panier mais il ne s'affiche pas.
       On demande donc exactement ce que le thème demande lui-même. */
    const drawer = document.querySelector('cart-drawer');
    const sectionId = drawer && drawer.dataset.sectionId;
    if (sectionId) {
      body.sections = [sectionId, 'auto-gifts'].join(',');
      body.sections_url = window.location.pathname;
    }

    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const payload = await res.json();
      if (!res.ok) throw new Error(payload.description || payload.message || 'Add to cart failed');

      /* La relecture du panier ne sert qu'au compteur. Sur le domaine
         myshopify elle part en 301 vers le domaine canonique et se fait
         bloquer par CORS : elle ne doit pas faire échouer un ajout réussi. */
      let cart = null;
      try {
        cart = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();
      } catch (e) {
        console.warn('[fk-offers] panier non relu, ajout conservé', e);
      }

      document.dispatchEvent(
        Object.assign(new Event('cart:updated', { bubbles: true }), {
          detail: {
            resource: cart,
            data: {
              source: 'fk-offers',
              itemCount: cart ? cart.item_count : undefined,
              sections: payload.sections,
              variantId: el.dataset.fkVariant,
            },
          },
        })
      );
      // Le tiroir n'existe pas sur tous les gabarits : sans lui, on va au panier.
      if (drawer) {
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      } else {
        window.location.href = window.Shopify.routes.root + 'cart';
        return;
      }
    } catch (error) {
      this.showError(this.dataset.fkErrorText || 'Something went wrong. Please try again.');
      console.error('[fk-offers]', error);
    } finally {
      button.disabled = false;
      button.textContent = idle;
    }
  }

  /* La barre ne s'affiche que pendant la traversée de la section : ailleurs,
     c'est la barre du thème qui reprend la main. */
  watchBar() {
    this.barObserver = new IntersectionObserver(
      (entries) => {
        const shown = entries[0].isIntersecting;
        this.bar.dataset.shown = shown ? 'true' : 'false';
        if (shown) document.documentElement.setAttribute('data-fk-offers-bar', 'on');
        else document.documentElement.removeAttribute('data-fk-offers-bar');
      },
      { rootMargin: '-40% 0px -20% 0px' }
    );
    const anchor = this.querySelector('.fk-offers__grid') || this;
    this.barObserver.observe(anchor);
  }
}

if (!customElements.get('fk-offers')) customElements.define('fk-offers', FkOffers);
